<div class="tags-wrapper">
        <div class="copyClipboard" (click)="copyTextToClipboard()" (mouseleave)="reset()">
                <span  [attr.data-gloss]="isCopied?'Copied': copyMessage" class="downPopUp" [class.mincontent_2]="isCopied">
                        <span class="ds_c-label">
                                {{label}} 
                        </span>
                </span>
        </div>
</div>